import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import MeterArchitecture from '../components/energy/MeterArchitecture';
import FlowVision from '../components/energy/FlowVision';
import DataEntry from '../components/energy/DataEntry';
import MeterReadings from '../components/energy/MeterReadings';
import AnalyticsDashboard from '../components/energy/AnalyticsDashboard';

const EnergyManagementSystem: React.FC = () => {
  const location = useLocation();

  // Determine which component to render based on route
  const renderComponent = () => {
    if (location.pathname === '/energy-management-system/data-entry') {
      return <DataEntry />;
    } else if (location.pathname === '/energy-management-system/flowvision') {
      return <FlowVision />;
    } else if (location.pathname === '/energy-management-system/meter-readings') {
      return <MeterReadings />;
    } else if (location.pathname === '/energy-management-system/analytics') {
      return <AnalyticsDashboard />;
    } else {
      return <MeterArchitecture />;
    }
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 }, overflowX: 'hidden' }}>
      {renderComponent()}
    </Box>
  );
};

export default EnergyManagementSystem;
